import { FormsPropertiesValues } from "./FormsPropertiesValues";
import { ListOfPropertiesValues } from "./ListOfPropertiesValues";
import { MedicalAppointmentValues } from "./MedicalAppointmentValues";
import { OrdersPropertiesValues } from "./OrdersPropertiesValues";
import { ServicesPropertiesValues } from "./ServicesPropertiesValues";
import { SessionsPropertiesValues } from "./SessionsPropertiesValues";
import { TasksPropertiesValues } from "./TasksPropertiesValues";
import { UsersPropertiesValues } from "./UsersPropertiesValues";
import { AvailabilitiesValues } from "./AvailabilitiesValues";
import { NotificationsPropertiesValues } from "./NotificationsPropertiesValues";
import { GeneralRulesPropertiesValues } from "./GeneralRulesPropertiesValues";
import { ScheduledActionsPropertiesValues } from "./ScheduledActionsPropertiesValues";
import { RDAPropertiesValues } from "./RDAPropertiesValues";

export class SelectCollection {
  ordersInstance: ListOfPropertiesValues = new OrdersPropertiesValues();
  usersInstance: ListOfPropertiesValues = new UsersPropertiesValues();
  servicesInstance: ListOfPropertiesValues = new ServicesPropertiesValues();
  sessionsInstance: ListOfPropertiesValues = new SessionsPropertiesValues();
  formsInstance: ListOfPropertiesValues = new FormsPropertiesValues();
  tasksInstance: ListOfPropertiesValues = new TasksPropertiesValues();
  medicalAppointmentInstance: ListOfPropertiesValues = new MedicalAppointmentValues();
  availabilitiesInstance: ListOfPropertiesValues = new AvailabilitiesValues();
  notificationsInstance: ListOfPropertiesValues = new NotificationsPropertiesValues();
  generalRulesInstance: ListOfPropertiesValues = new GeneralRulesPropertiesValues();
  scheduledActionsInstance: ListOfPropertiesValues = new ScheduledActionsPropertiesValues();
  rdaInstance: ListOfPropertiesValues = new RDAPropertiesValues();

  get medicalOrders() {
    return this.ordersInstance;
  }

  get users() {
    return this.usersInstance;
  }

  get services() {
    return this.servicesInstance;
  }

  get sessions() {
    return this.sessionsInstance;
  }

  get forms() {
    return this.formsInstance;
  }

  get tasks() {
    return this.tasksInstance;
  }

  get medicalAppointments() {
    return this.medicalAppointmentInstance;
  }

  get availabilities() {
    return this.availabilitiesInstance;
  }

  get notifications() {
    return this.notificationsInstance;
  }

  get generalRules() {
    return this.generalRulesInstance;
  }

  get scheduledActions() {
    return this.scheduledActionsInstance;
  }

  get rda() {
    return this.rdaInstance;
  }
}
